import waves from "./waves";

export default waves;
